export default function Canvas_Shadows() {
  return (
    <div>
      <h1>Canvas_Shadows Component</h1>
    </div>
  );
}
